<template>
  <div class="ui grid">
    <div class="row">
      <h1 class="ui huge header">Website</h1>
    </div>
    <div class="ui divider"></div>
    <div class="row">
      <p v-if="user">
        Select the options below to manage the various sections of our website
      </p>
    </div>
    <div class="row">
      <div class="ui divided items">
        <div v-if="user.profile.role === 'Administrator'" class="item">
          <div class="image">
            <router-link to="/website/news"><i class="massive newspaper icon"></i></router-link>
          </div>
          <div class="content">
            <div class="header">Manage news</div>
            <div class="meta">
              <span>Select to manage the news section</span>
            </div>
            <div class="description">
              <!-- eslint-disable-next-line max-len -->
              With this option you can add news articles to the website and manage the
              existing ones.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Index',
  components: {},
  computed: mapGetters({
    user: 'user',
    usersSchool: 'usersSchool',
  }),
  data() {
    return {};
  },
  methods: {},
  created() {
    this.$store.dispatch('hideLoader');
  },
};
</script>



// WEBPACK FOOTER //
// src/components/website/Index.vue